import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

const CharacterSection = ({ character, onUpdate, onDelete, suggestions, setSuggestions }) => {
  console.log('CharacterSection props:', { character, suggestions }); // Log props
  
  const [description, setDescription] = useState(character.description);
  const [characterArc, setCharacterArc] = useState(character.characterArc);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      onUpdate({
        ...character,
        description,
        characterArc,
      });
    }, 500);
    
    return () => clearTimeout(timer);
  }, [description, characterArc]);
  
  const handleDismissSuggestion = (index) => {
    // Get character's lowercase name for consistent key lookup
    const characterKey = character.name.toLowerCase();
    
    setSuggestions((prev) => {
      const updated = { ...prev };
      
      // Ensure characters domain exists
      if (!updated.characters) {
        updated.characters = {};
      }
      
      // Ensure this character exists in the suggestions
      if (!updated.characters[characterKey]) {
        updated.characters[characterKey] = [];
      }
      
      // Filter out the dismissed suggestion
      updated.characters[characterKey] = updated.characters[characterKey].filter(
        (_, i) => i !== index
      );
      
      return updated;
    });
  };
  
  const handleImplementSuggestion = (content, index) => {
    // Update the character description
    setDescription((prev) => `${prev}\n${content}`);
    
    // Dismiss the suggestion after implementing
    handleDismissSuggestion(index);
  };
  
  // Get character suggestions using character's lowercase name for consistent lookup
  const characterKey = character.name.toLowerCase();
  const characterSuggestions = suggestions?.characters?.[characterKey] || [];
  
  return (
    <div className="card mb-3 shadow-sm">
      <div className="card-header bg-light d-flex justify-content-between align-items-center">
        <h5 className="mb-0">{character.name}</h5>
        <button
          className="btn btn-outline-danger btn-sm"
          onClick={() => onDelete(character.name)}
        >
          <FontAwesomeIcon icon={faTrash} /> Delete
        </button>
      </div>
      <div className="card-body">
        <div className="mb-3">
          <label className="form-label">Description</label>
          <textarea
            className="form-control"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={3}
          />
        </div>
        <div>
          <label className="form-label">Character Arc</label>
          <textarea
            className="form-control"
            value={characterArc}
            onChange={(e) => setCharacterArc(e.target.value)}
            rows={3}
          />
        </div>
        {characterSuggestions.length > 0 && (
          <div className="mt-3 bg-light p-3 rounded">
            <h6>Suggestions for {character.name}</h6>
            <ul className="list-unstyled">
              {characterSuggestions.map((suggestion, index) => (
                <li key={index} className="mb-3 p-2 border rounded bg-white">
                  {suggestion.issue && (
                    <div className="small text-muted mb-1">
                      <strong>Issue:</strong> {suggestion.issue}
                    </div>
                  )}
                  <p className="mb-2">{suggestion.content}</p>
                  {suggestion.impact && (
                    <div className="small text-muted mb-2">
                      <strong>Impact:</strong> {suggestion.impact}
                    </div>
                  )}
                  <div className="d-flex">
                    <button
                      className="btn btn-outline-success btn-sm me-2"
                      onClick={() => handleImplementSuggestion(suggestion.content, index)}
                    >
                      Implement
                    </button>
                    <button
                      className="btn btn-outline-secondary btn-sm"
                      onClick={() => handleDismissSuggestion(index)}
                    >
                      Dismiss
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default CharacterSection;